import { render, staticRenderFns } from "./ClaimTypeModal.vue?vue&type=template&id=f2277c00"
import script from "./ClaimTypeModal.vue?vue&type=script&lang=js"
export * from "./ClaimTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports